/**
 * Chart display constants only.
 * S-curve series building moved to overview/charts/chartUtils.ts.
 * Normalization and metric computation belong in utils/analyticsCompute.
 */

// ---------------------------------------------------------------------------
// Constants (used by charts and page)
// ---------------------------------------------------------------------------

export const BUCKET_TO_FLOAT_RANGE: Record<string, { min?: number; max?: number }> = {
  '<0': {},
  '0': {},
  '1-7': { min: 0.001, max: 7 },
  '8-14': { min: 8, max: 14 },
  '15-30': { min: 15, max: 30 },
  '31-44': { min: 31, max: 44 },
  '>44': { min: 45 },
};

/** Quality Issues x-axis: compact labels for overview, full in tooltip. Order matches computeQualityChecks. */
export const QUALITY_AXIS_LABELS: Array<{ key: string; short: string; full: string }> = [
  { key: 'high_float_pct', short: 'High float\n% (>44d)', full: 'High float % (>44d)' },
  { key: 'long_duration_pct', short: 'Long dur\n% (>44d)', full: 'Long duration % (>44d)' },
  { key: 'missing_predecessors', short: 'Missing\npreds', full: 'Missing predecessors' },
  { key: 'missing_successors', short: 'Missing\nsuccs', full: 'Missing successors' },
  { key: 'constraints_count', short: 'Constraints', full: 'Constraints count' },
  { key: 'excessive_lags', short: 'Excess\nlags', full: 'Excessive lags' },
];
